import React, { PropsWithChildren } from 'react';

import cx from 'classnames';
import { Control } from 'react-hook-form';

import { HookInput } from 'components/shared/HookFormComponents';
import Text from 'components/shared/Typography/Text';

import sharedStyles from '../../../../shared/index.module.css';
import { DefaultFormValues } from '../../types';

type TagsField = Pick<DefaultFormValues, 'name'>;

type Props<T extends TagsField> = PropsWithChildren<{
  control: Control<T>;
  nameInputPlaceholder?: string;
}>;

function NameSection<T extends TagsField>({ control, children, nameInputPlaceholder = 'Enter Name*' }: Props<T>) {
  return (
    <>
      <div className={sharedStyles.headlineContainer}>
        <Text className={cx(sharedStyles.cssHeadline, sharedStyles.titleContainer)} type="brandon" isStrong>
          {children}
        </Text>
        <Text type="brandon" className={sharedStyles.descriptionText}>
          The name of a page will appear throughout the client facing itinerary.
        </Text>
      </div>

      <div className={sharedStyles.adapterContainer}>
        <HookInput
          name="name"
          // @ts-ignore // TODO: fix with HookInput refactoring
          control={control}
          label={nameInputPlaceholder}
          optionToString
        />
      </div>
    </>
  );
}

export { NameSection };
